export const transferOrderStatuses = {
  draft: 'Draft',
  open: 'Open',
  receiving: 'Receiving',
  received: 'Received',
  closed: 'Closed',
  cancelled: 'Cancelled',
} as const;

export type TransferOrderStatus = (typeof transferOrderStatuses)[keyof typeof transferOrderStatuses];
